// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/mcp.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { MCP, MCPClass, MCPTool } from "../v1/mcp_pb.js";
import { file_agentplatform_v1_mcp } from "../v1/mcp_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/mcp.proto.
 */
export const file_agentplatform_httpv2_mcp: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v1_mcp, file_buf_validate_validate, file_gnostic_openapi_v3_annotations, file_google_api_annotations]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMCPsResponse
 */
export type ListMCPsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListMCPsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListMCPsData data = 4;
   */
  data?: ListMCPsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMCPsResponse.
 * Use `create(ListMCPsResponseSchema)` to create a new message.
 */
export const ListMCPsResponseSchema: GenMessage<ListMCPsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 0);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMCPsData
 */
export type ListMCPsData = Message<"infinigence.infini.agentplatform.httpv2.ListMCPsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.MCP items = 1;
   */
  items: MCP[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMCPsData.
 * Use `create(ListMCPsDataSchema)` to create a new message.
 */
export const ListMCPsDataSchema: GenMessage<ListMCPsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMCPRequest
 */
export type CreateMCPRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateMCPRequest"> & {
  /**
   * MCP 实例定义（归属 tenant_id / user_id 由服务端从鉴权信息回填）
   * @gotags: json:"mcp"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCP mcp = 1;
   */
  mcp?: MCP | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMCPRequest.
 * Use `create(CreateMCPRequestSchema)` to create a new message.
 */
export const CreateMCPRequestSchema: GenMessage<CreateMCPRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMCPResponse
 */
export type CreateMCPResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateMCPResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCP data = 4;
   */
  data?: MCP | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMCPResponse.
 * Use `create(CreateMCPResponseSchema)` to create a new message.
 */
export const CreateMCPResponseSchema: GenMessage<CreateMCPResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMCPRequest
 */
export type GetMCPRequest = Message<"infinigence.infini.agentplatform.httpv2.GetMCPRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMCPRequest.
 * Use `create(GetMCPRequestSchema)` to create a new message.
 */
export const GetMCPRequestSchema: GenMessage<GetMCPRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMCPResponse
 */
export type GetMCPResponse = Message<"infinigence.infini.agentplatform.httpv2.GetMCPResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCP data = 4;
   */
  data?: MCP | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMCPResponse.
 * Use `create(GetMCPResponseSchema)` to create a new message.
 */
export const GetMCPResponseSchema: GenMessage<GetMCPResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMCPRequest
 */
export type UpdateMCPRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateMCPRequest"> & {
  /**
   * 待更新 MCP 实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * MCP 实例定义（id / 归属由服务端回填）
   * @gotags: json:"mcp"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCP mcp = 2;
   */
  mcp?: MCP | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMCPRequest.
 * Use `create(UpdateMCPRequestSchema)` to create a new message.
 */
export const UpdateMCPRequestSchema: GenMessage<UpdateMCPRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 6);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMCPResponse
 */
export type UpdateMCPResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateMCPResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCP data = 4;
   */
  data?: MCP | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMCPResponse.
 * Use `create(UpdateMCPResponseSchema)` to create a new message.
 */
export const UpdateMCPResponseSchema: GenMessage<UpdateMCPResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMCPRequest
 */
export type DeleteMCPRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteMCPRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMCPRequest.
 * Use `create(DeleteMCPRequestSchema)` to create a new message.
 */
export const DeleteMCPRequestSchema: GenMessage<DeleteMCPRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 8);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMCPResponse
 */
export type DeleteMCPResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteMCPResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMCPResponse.
 * Use `create(DeleteMCPResponseSchema)` to create a new message.
 */
export const DeleteMCPResponseSchema: GenMessage<DeleteMCPResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMCPToolsRequest
 */
export type ListMCPToolsRequest = Message<"infinigence.infini.agentplatform.httpv2.ListMCPToolsRequest"> & {
  /**
   * MCP 实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMCPToolsRequest.
 * Use `create(ListMCPToolsRequestSchema)` to create a new message.
 */
export const ListMCPToolsRequestSchema: GenMessage<ListMCPToolsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 10);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMCPToolsResponse
 */
export type ListMCPToolsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListMCPToolsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListMCPToolsData data = 4;
   */
  data?: ListMCPToolsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMCPToolsResponse.
 * Use `create(ListMCPToolsResponseSchema)` to create a new message.
 */
export const ListMCPToolsResponseSchema: GenMessage<ListMCPToolsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMCPToolsData
 */
export type ListMCPToolsData = Message<"infinigence.infini.agentplatform.httpv2.ListMCPToolsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.MCPTool items = 1;
   */
  items: MCPTool[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMCPToolsData.
 * Use `create(ListMCPToolsDataSchema)` to create a new message.
 */
export const ListMCPToolsDataSchema: GenMessage<ListMCPToolsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.TestMCPConnectionRequest
 */
export type TestMCPConnectionRequest = Message<"infinigence.infini.agentplatform.httpv2.TestMCPConnectionRequest"> & {
  /**
   * MCP 实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.TestMCPConnectionRequest.
 * Use `create(TestMCPConnectionRequestSchema)` to create a new message.
 */
export const TestMCPConnectionRequestSchema: GenMessage<TestMCPConnectionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.TestMCPConnectionResponse
 */
export type TestMCPConnectionResponse = Message<"infinigence.infini.agentplatform.httpv2.TestMCPConnectionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.TestMCPConnectionData data = 4;
   */
  data?: TestMCPConnectionData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.TestMCPConnectionResponse.
 * Use `create(TestMCPConnectionResponseSchema)` to create a new message.
 */
export const TestMCPConnectionResponseSchema: GenMessage<TestMCPConnectionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.TestMCPConnectionData
 */
export type TestMCPConnectionData = Message<"infinigence.infini.agentplatform.httpv2.TestMCPConnectionData"> & {
  /**
   * 连接是否成功
   * @gotags: json:"ok"
   *
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * 失败原因（成功时为空）
   * @gotags: json:"error,omitempty"
   *
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * 探活耗时（毫秒）
   * @gotags: json:"latency_ms"
   *
   * @generated from field: int64 latency_ms = 3 [json_name = "latency_ms"];
   */
  latencyMs: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.TestMCPConnectionData.
 * Use `create(TestMCPConnectionDataSchema)` to create a new message.
 */
export const TestMCPConnectionDataSchema: GenMessage<TestMCPConnectionData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMCPClassesResponse
 */
export type ListMCPClassesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListMCPClassesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListMCPClassesData data = 4;
   */
  data?: ListMCPClassesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMCPClassesResponse.
 * Use `create(ListMCPClassesResponseSchema)` to create a new message.
 */
export const ListMCPClassesResponseSchema: GenMessage<ListMCPClassesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 16);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMCPClassesData
 */
export type ListMCPClassesData = Message<"infinigence.infini.agentplatform.httpv2.ListMCPClassesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.MCPClass items = 1;
   */
  items: MCPClass[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMCPClassesData.
 * Use `create(ListMCPClassesDataSchema)` to create a new message.
 */
export const ListMCPClassesDataSchema: GenMessage<ListMCPClassesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 17);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMCPClassRequest
 */
export type CreateMCPClassRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateMCPClassRequest"> & {
  /**
   * MCP 服务类定义（归属 tenant_id / user_id 由服务端从鉴权信息回填）
   * @gotags: json:"mcp_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCPClass mcp_class = 1 [json_name = "mcp_class"];
   */
  mcpClass?: MCPClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMCPClassRequest.
 * Use `create(CreateMCPClassRequestSchema)` to create a new message.
 */
export const CreateMCPClassRequestSchema: GenMessage<CreateMCPClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 18);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMCPClassResponse
 */
export type CreateMCPClassResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateMCPClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCPClass data = 4;
   */
  data?: MCPClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMCPClassResponse.
 * Use `create(CreateMCPClassResponseSchema)` to create a new message.
 */
export const CreateMCPClassResponseSchema: GenMessage<CreateMCPClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 19);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMCPClassRequest
 */
export type GetMCPClassRequest = Message<"infinigence.infini.agentplatform.httpv2.GetMCPClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMCPClassRequest.
 * Use `create(GetMCPClassRequestSchema)` to create a new message.
 */
export const GetMCPClassRequestSchema: GenMessage<GetMCPClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 20);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMCPClassResponse
 */
export type GetMCPClassResponse = Message<"infinigence.infini.agentplatform.httpv2.GetMCPClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCPClass data = 4;
   */
  data?: MCPClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMCPClassResponse.
 * Use `create(GetMCPClassResponseSchema)` to create a new message.
 */
export const GetMCPClassResponseSchema: GenMessage<GetMCPClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 21);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMCPClassRequest
 */
export type UpdateMCPClassRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateMCPClassRequest"> & {
  /**
   * 待更新 MCP 服务类 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * MCP 服务类定义（归属由服务端回填）
   * @gotags: json:"mcp_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCPClass mcp_class = 2 [json_name = "mcp_class"];
   */
  mcpClass?: MCPClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMCPClassRequest.
 * Use `create(UpdateMCPClassRequestSchema)` to create a new message.
 */
export const UpdateMCPClassRequestSchema: GenMessage<UpdateMCPClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 22);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMCPClassResponse
 */
export type UpdateMCPClassResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateMCPClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCPClass data = 4;
   */
  data?: MCPClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMCPClassResponse.
 * Use `create(UpdateMCPClassResponseSchema)` to create a new message.
 */
export const UpdateMCPClassResponseSchema: GenMessage<UpdateMCPClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 23);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMCPClassRequest
 */
export type DeleteMCPClassRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteMCPClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMCPClassRequest.
 * Use `create(DeleteMCPClassRequestSchema)` to create a new message.
 */
export const DeleteMCPClassRequestSchema: GenMessage<DeleteMCPClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 24);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMCPClassResponse
 */
export type DeleteMCPClassResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteMCPClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMCPClassResponse.
 * Use `create(DeleteMCPClassResponseSchema)` to create a new message.
 */
export const DeleteMCPClassResponseSchema: GenMessage<DeleteMCPClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 25);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMCPInstanceFromClassRequest
 */
export type CreateMCPInstanceFromClassRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateMCPInstanceFromClassRequest"> & {
  /**
   * MCP 服务类 ID
   * @gotags: json:"class_id"
   *
   * @generated from field: string class_id = 1 [json_name = "class_id"];
   */
  classId: string;

  /**
   * 实例名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 实例描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 类参数取值
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: map<string, string> params = 4;
   */
  params: { [key: string]: string };
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMCPInstanceFromClassRequest.
 * Use `create(CreateMCPInstanceFromClassRequestSchema)` to create a new message.
 */
export const CreateMCPInstanceFromClassRequestSchema: GenMessage<CreateMCPInstanceFromClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 26);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMCPInstanceFromClassResponse
 */
export type CreateMCPInstanceFromClassResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateMCPInstanceFromClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCP data = 4;
   */
  data?: MCP | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMCPInstanceFromClassResponse.
 * Use `create(CreateMCPInstanceFromClassResponseSchema)` to create a new message.
 */
export const CreateMCPInstanceFromClassResponseSchema: GenMessage<CreateMCPInstanceFromClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 27);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMCPInstanceFromClassRequest
 */
export type UpdateMCPInstanceFromClassRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateMCPInstanceFromClassRequest"> & {
  /**
   * MCP 服务类 ID
   * @gotags: json:"class_id"
   *
   * @generated from field: string class_id = 1 [json_name = "class_id"];
   */
  classId: string;

  /**
   * 待更新 MCP 实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * 实例名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 实例描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 类参数取值
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: map<string, string> params = 5;
   */
  params: { [key: string]: string };
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMCPInstanceFromClassRequest.
 * Use `create(UpdateMCPInstanceFromClassRequestSchema)` to create a new message.
 */
export const UpdateMCPInstanceFromClassRequestSchema: GenMessage<UpdateMCPInstanceFromClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 28);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMCPInstanceFromClassResponse
 */
export type UpdateMCPInstanceFromClassResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateMCPInstanceFromClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCP data = 4;
   */
  data?: MCP | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMCPInstanceFromClassResponse.
 * Use `create(UpdateMCPInstanceFromClassResponseSchema)` to create a new message.
 */
export const UpdateMCPInstanceFromClassResponseSchema: GenMessage<UpdateMCPInstanceFromClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_mcp, 29);

/**
 * MCPHTTPV2Service
 * MCP 实例 / MCP 服务类 的 CRUD，以及工具列举与连通性探测
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service
 */
export const MCPHTTPV2Service: GenService<{
  /**
   * ---- MCP Instance ----
   * 列出 MCP 实例（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.ListMCPs
   */
  listMCPs: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListMCPsResponseSchema;
  },
  /**
   * 创建 MCP 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.CreateMCP
   */
  createMCP: {
    methodKind: "unary";
    input: typeof CreateMCPRequestSchema;
    output: typeof CreateMCPResponseSchema;
  },
  /**
   * 获取单个 MCP 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.GetMCP
   */
  getMCP: {
    methodKind: "unary";
    input: typeof GetMCPRequestSchema;
    output: typeof GetMCPResponseSchema;
  },
  /**
   * 更新 MCP 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.UpdateMCP
   */
  updateMCP: {
    methodKind: "unary";
    input: typeof UpdateMCPRequestSchema;
    output: typeof UpdateMCPResponseSchema;
  },
  /**
   * 删除 MCP 实例（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.DeleteMCP
   */
  deleteMCP: {
    methodKind: "unary";
    input: typeof DeleteMCPRequestSchema;
    output: typeof DeleteMCPResponseSchema;
  },
  /**
   * 列出 MCP 实例暴露的工具
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.ListMCPTools
   */
  listMCPTools: {
    methodKind: "unary";
    input: typeof ListMCPToolsRequestSchema;
    output: typeof ListMCPToolsResponseSchema;
  },
  /**
   * 测试 MCP 实例连通性
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.TestMCPConnection
   */
  testMCPConnection: {
    methodKind: "unary";
    input: typeof TestMCPConnectionRequestSchema;
    output: typeof TestMCPConnectionResponseSchema;
  },
  /**
   * ---- MCP Class ----
   * 列出 MCP 服务类（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.ListMCPClasses
   */
  listMCPClasses: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListMCPClassesResponseSchema;
  },
  /**
   * 创建 MCP 服务类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.CreateMCPClass
   */
  createMCPClass: {
    methodKind: "unary";
    input: typeof CreateMCPClassRequestSchema;
    output: typeof CreateMCPClassResponseSchema;
  },
  /**
   * 获取单个 MCP 服务类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.GetMCPClass
   */
  getMCPClass: {
    methodKind: "unary";
    input: typeof GetMCPClassRequestSchema;
    output: typeof GetMCPClassResponseSchema;
  },
  /**
   * 更新 MCP 服务类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.UpdateMCPClass
   */
  updateMCPClass: {
    methodKind: "unary";
    input: typeof UpdateMCPClassRequestSchema;
    output: typeof UpdateMCPClassResponseSchema;
  },
  /**
   * 删除 MCP 服务类（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.DeleteMCPClass
   */
  deleteMCPClass: {
    methodKind: "unary";
    input: typeof DeleteMCPClassRequestSchema;
    output: typeof DeleteMCPClassResponseSchema;
  },
  /**
   * ---- MCP Instance from Class ----
   * 基于 MCP 服务类创建 MCP 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.CreateMCPInstanceFromClass
   */
  createMCPInstanceFromClass: {
    methodKind: "unary";
    input: typeof CreateMCPInstanceFromClassRequestSchema;
    output: typeof CreateMCPInstanceFromClassResponseSchema;
  },
  /**
   * 基于 MCP 服务类更新 MCP 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MCPHTTPV2Service.UpdateMCPInstanceFromClass
   */
  updateMCPInstanceFromClass: {
    methodKind: "unary";
    input: typeof UpdateMCPInstanceFromClassRequestSchema;
    output: typeof UpdateMCPInstanceFromClassResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_mcp, 0);

